import React from 'react'
import Navbar from '../navbar'
import Footer from '../Footer'
import Services from '../Services'

const Service = () => {
    return (
        <>
            <Navbar />

            <Services />

            <Footer />
        </>
    )
}

export default Service